import { debounceFactory } from './debounce';

export const debounceImmediate = debounceFactory(true);
